// api_details is now initialized in custom-design-customizer.liquid
var brokenNativeVariant = {};
var brokenVariantString = "";
var brokenValues = {};

function getBrokenValues() {
	let hiddenInputs = document.querySelectorAll(".defaultCheckbox");
	hiddenInputs.forEach((input) => {
		let className = Array.from(input.classList).find((c) =>
			c.endsWith("HiddenInput"),
		);
		if (className) {
			let key = className.replace("HiddenInput", "");
			brokenNativeVariant[key] = input.value;
		}
	});
	brokenVariantString = Object.values(brokenNativeVariant).join(" ");
	return brokenNativeVariant;
}

// Stubs for functions referenced in user's toggle logic
function updateGalleryImageValueForBrokenValues(formattedVariant) {
	// In our existing system, updateVariantId handles thumbnail clicking
	updateVariantId();
}

function validatePrice(finalVariantValue) {
	// Mirror the backup: find the variant whose title matches and update the price display.
	// This is the primary price-update path — it fires even before updateVariantId() runs.
	if (finalVariantValue && window.productVariants) {
		const found = window.productVariants.find(
			(v) => v.title === finalVariantValue,
		);
		if (found) updatePriceDisplay(found);
	}
	updateSubtotal();
}

// Updates .originalPrice, .compare-at-price, .pricePercentage, and .subTotalPrice
// from the real Shopify variant price — mirrors the backup's updatePriceContainer logic.
function updatePriceDisplay(variant) {
	if (!variant) return;

	const price = variant.price / 100;
	const compareAtPrice = variant.compare_at_price
		? variant.compare_at_price / 100
		: 0;
	const hasSale = compareAtPrice > 0 && compareAtPrice > price;

	// ── Main price (.originalPrice) ──
	const priceEl = document.querySelector(".originalPrice");
	if (priceEl) {
		priceEl.textContent = `$${price.toFixed(2)}`;
	}

	// ── Compare-at / strikethrough price ──
	const compareEl = document.querySelector(
		".compare-at-price[data-compare-at-price]",
	);
	if (compareEl) {
		if (hasSale) {
			compareEl.textContent = `$${compareAtPrice.toFixed(2)}`;
			compareEl.style.display = "";
		} else {
			compareEl.style.display = "none";
		}
	}

	// ── "You save" percentage ──
	const savingsEl = document.querySelector(".pricePercentage");
	const savingsDefaultEl = document.querySelector(".pricePercentageDefault");

	if (savingsEl) {
		savingsEl.textContent = ""; // clear previous dynamic content
		if (hasSale) {
			const amountSaved = compareAtPrice - price;
			const discountPct = Math.floor((amountSaved / compareAtPrice) * 100);
			const p = document.createElement("p");
			p.textContent = `You save: ${discountPct}% ($${amountSaved.toFixed(2)})`;
			savingsEl.appendChild(p);
			// Hide the server-rendered default so we don't double-show
			if (savingsDefaultEl) savingsDefaultEl.style.display = "none";
		} else {
			// No discount on this variant — restore server default if it exists
			if (savingsDefaultEl) savingsDefaultEl.style.display = "none";
		}
	}

	// ── Subtotal display(s) — set base to variant price so Extras can still stack ──
	const subtotalEls = document.querySelectorAll(".subTotalPrice");
	subtotalEls.forEach((el) => {
		el.setAttribute("data-base-price", price.toFixed(2));
	});
	updateSubtotal();
	updateButtonTotal(); 
}

const CUSTOMIZER_SCROLL_OFFSET = 80;

function scrollToCustomizerTop() {
	const el =
		document.querySelector(".custom-design-progress-bar") ||
		document.querySelector(".customizer-steps-container");
	if (!el) return;

	requestAnimationFrame(() => {
		const top =
			el.getBoundingClientRect().top +
			window.scrollY -
			CUSTOMIZER_SCROLL_OFFSET;
		window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
	});
}

function goToNextStep(currentIndex) {
	const steps = document.querySelectorAll(
		".customizer-steps-container .step-block",
	);

	if (currentIndex < steps.length - 1) {
		steps[currentIndex].classList.remove("active");
		steps[currentIndex + 1].classList.add("active");
		if (typeof setActiveStep === "function") {
			setActiveStep(currentIndex + 1);
		}
		scrollToCustomizerTop();
	}
}

function goToPrevStep(currentIndex) {
	const steps = document.querySelectorAll(
		".customizer-steps-container .step-block",
	);

	if (currentIndex > 0) {
		steps[currentIndex].classList.remove("active");
		steps[currentIndex - 1].classList.add("active");
		if (typeof setActiveStep === "function") {
			setActiveStep(currentIndex - 1);
		}
		scrollToCustomizerTop();
	}
}

function syncCustomizerState() {
	// 1. Build composite key from ALL active toggle values
	const allToggleInputs = document.querySelectorAll(".toggleCheckboxes");
	const keyParts = Array.from(allToggleInputs).map((inp) =>
		inp.value
			.toLowerCase()
			.replace(/\s+/g, "_")
			.replace(/[^a-z0-9_]/g, ""),
	);
	const combinedKey = keyParts.filter(Boolean).join("_");

	// 2. Filter ALL swatches on the page
	const allSwatchDivs = document.querySelectorAll(".swatchDiv");
	allSwatchDivs.forEach((sw) => {
		const showWithMatch = sw.className.match(/show_with_([^\s]+)/);
		if (showWithMatch) {
			sw.style.display = showWithMatch[1] === combinedKey ? "block" : "none";
		} else if (sw.classList.contains("simpleShowOption")) {
			sw.style.display = "block";
		}
	});

	// 3. Update hidden inputs for all active containers to ensure state consistency
	document.querySelectorAll(".toggle-choice-container").forEach((container) => {
		const checkbox = container.querySelector(".checkbox");
		const firstCase = container.querySelector(`[class*="FirstCase"]`);
		const secondCase = container.querySelector(`[class*="SecondCase"]`);

		if (checkbox && firstCase && secondCase) {
			const activeCase = checkbox.checked ? secondCase : firstCase;

			// Selection Ripple: If no swatch is selected in the active visible set, click the first one
			const selectedInCase = activeCase.querySelector(".swatchImage.selected");
			const firstVisible = Array.from(
				activeCase.querySelectorAll(".swatchDiv"),
			).find((sw) => sw.style.display !== "none");

			if (!selectedInCase && firstVisible) {
				const img = firstVisible.querySelector(".swatchImage");
				if (img) {
					img.click();
				}
			}
		}
	});

	updateSubtotal();
	updateVariantId();
}

function handleToggleSwitch(
	toggleSwitch,
	name,
	firstValue,
	secondValue,
	brokenVariantName,
	stepname,
	swatchesWithFirst,
	swatchesWithSecond,
) {
	const hiddenInput = document.querySelector(
		`.${brokenVariantName}ToggleHiddenInputs`,
	);
	const firstCase = document.querySelector(
		`.${firstValue.toLowerCase().replace(/ /g, "")}FirstCase`,
	);
	const secondCase = document.querySelector(
		`.${secondValue.toLowerCase().replace(/ /g, "")}SecondCase`,
	);

	if (toggleSwitch.checked) {
		if (hiddenInput) hiddenInput.value = secondValue;
		brokenNativeVariant[brokenVariantName] = secondValue;

		const checkboxInputValues = document.querySelectorAll(".toggleCheckboxes");
		let togglesValue = Array.from(checkboxInputValues)
			.map((inputValue) => inputValue.value.replace(/\s+/g, "_").toLowerCase())
			.join("_");

		let firstDivImage = null;
		if (firstCase && secondCase) {
			firstCase.style.display = "none";
			secondCase.style.display = "flex";

			const selectiveSwatchesToHide = document.querySelectorAll(`.swatchDiv`);
			selectiveSwatchesToHide.forEach((swatch, index) => {
				const hasShowWithClass = Array.from(swatch.classList).some(
					(className) => className.startsWith("show_with"),
				);
				if (hasShowWithClass) {
					if (swatch.classList.contains(`show_with_${togglesValue}`)) {
						swatch.style.display = "block";
						if (!firstDivImage) firstDivImage = swatch;
					}
					// else {
					//     swatch.style.display = 'none';
					// }
				} else {
					if (swatch.classList.contains(`simpleShowOption`)) {
						swatch.style.display = "block";
						if (!firstDivImage) firstDivImage = swatch;
					}
				}
			});

			if (firstDivImage) {
				const swatch_image = firstDivImage.querySelector("img");
				if (swatch_image) swatch_image.click();
			}
		}

		if (!firstCase && !secondCase && swatchesWithSecond === togglesValue) {
			const selectiveSwatchesToHide = document.querySelectorAll(`.swatchDiv`);
			let firstVisibleSwatch = null;
			selectiveSwatchesToHide.forEach((swatch, index) => {
				const hasShowWithClass = Array.from(swatch.classList).some(
					(className) => className.startsWith("show_with"),
				);
				if (hasShowWithClass) {
					if (swatch.classList.contains(`show_with_${swatchesWithSecond}`)) {
						swatch.style.display = "block";
						if (!firstVisibleSwatch) firstVisibleSwatch = swatch;
					} else {
						swatch.style.display = "none";
					}
				}
			});
			const swatch_image = firstVisibleSwatch.querySelector("img");
			if (swatch_image) swatch_image.click();
		}

		brokenValues = getBrokenValues();
		if (window.formattedVariant) {
			window.formattedVariant["Material and Frame"] = brokenVariantString;
			updateGalleryImageValueForBrokenValues(window.formattedVariant);
			let finalVariantValue = Object.values(window.formattedVariant).join(
				" / ",
			);
			validatePrice(finalVariantValue);
		}
	} else {
		if (hiddenInput) hiddenInput.value = firstValue;
		brokenNativeVariant[brokenVariantName] = firstValue;

		if (firstCase && secondCase) {
			firstCase.style.display = "flex";
			secondCase.style.display = "none";

			if (swatchesWithFirst && swatchesWithSecond) {
				const selectiveSwatchesToDisplay = secondCase.querySelectorAll(
					`.swatchDiv:not(.show_with_${swatchesWithSecond})`,
				);
				selectiveSwatchesToDisplay.forEach((swatch, index) => {
					swatch.style.display = "block";
					if (index === 0) {
						const swatchImage = swatch.querySelector("img");
						if (swatchImage) swatchImage.click();
					}
				});

				const selectiveSwatchesToHide = secondCase.querySelectorAll(
					`.swatchDiv:not(.show_with_${swatchesWithSecond})`,
				);
				selectiveSwatchesToHide.forEach((swatch) => {
					swatch.style.display = "none";
				});
			}
		}

		const checkboxInputValues = document.querySelectorAll(".toggleCheckboxes");
		let togglesValue = Array.from(checkboxInputValues)
			.map((inputValue) => inputValue.value.replace(/\s+/g, "_").toLowerCase())
			.join("_");

		if (!firstCase && !secondCase && swatchesWithFirst === togglesValue) {
			const selectiveSwatchesToHide = document.querySelectorAll(`.swatchDiv`);
			let firstVisibleSwatch = null;
			selectiveSwatchesToHide.forEach((swatch, index) => {
				const hasShowWithClass = Array.from(swatch.classList).some(
					(className) => className.startsWith("show_with"),
				);
				if (hasShowWithClass) {
					if (swatch.classList.contains(`show_with_${swatchesWithFirst}`)) {
						swatch.style.display = "block";
						if (!firstVisibleSwatch) firstVisibleSwatch = swatch;
					} else {
						swatch.style.display = "none";
					}
				}
			});
			const swatchImage = firstVisibleSwatch.querySelector("img");
			if (swatchImage) swatchImage.click();
		} else {
			const swatchedDivName = firstValue.toLowerCase().replace(/\s/g, "");
			const attachedSwatchesContainer = document.querySelector(
				`.${swatchedDivName}FirstCase`,
			);
			if (attachedSwatchesContainer) {
				const attachedSwatches =
					attachedSwatchesContainer.querySelectorAll(".swatchDiv");
				let firstDivImage = null;
				attachedSwatches.forEach((swatch, index) => {
					if (swatch.classList.contains(`show_with_${togglesValue}`)) {
						swatch.style.display = "block";
						if (!firstDivImage) firstDivImage = swatch;
					} else {
						swatch.style.display = "none";
					}
				});
				if (firstDivImage) {
					const swatch_image = firstDivImage.querySelector("img");
					if (swatch_image) swatch_image.click();
				}
			}
		}

		brokenValues = getBrokenValues();
		if (window.formattedVariant) {
			window.formattedVariant["Material and Frame"] = brokenVariantString;
			updateGalleryImageValueForBrokenValues(window.formattedVariant);
			let finalVariantValue = Object.values(window.formattedVariant).join(
				" / ",
			);
			validatePrice(finalVariantValue);
		}
	}
}

function selectSubOptionSwatch(
	stepId,
	optionId,
	classname,
	label,
	el,
	extra_charges,
) {
	const parent = el.closest(".swatchContainer");
	parent
		.querySelectorAll(".swatchImage")
		.forEach((img) => img.classList.remove("selected"));
	el.classList.add("selected");

	// Update hidden input if exists (using the user's class naming convention)
	const stepBlock = el.closest(".step-block");
	const hiddenInput = stepBlock.querySelector(
		"." + optionId + classname + "HiddenInput",
	);
	if (hiddenInput) {
		hiddenInput.value = label;
	}

	// Update 'broken' state
	brokenValues = getBrokenValues();

	if (window.formattedVariant) {
		// In the user's system, the step-level value is the space-joined 'broken' string
		window.formattedVariant["Material and Frame"] = brokenVariantString;

		// Ensure the specific option is also tracked if needed (legacy support)
		const optionName = el.getAttribute("data-option-name");
		if (optionName) {
			window.formattedVariant[optionName] = label;
		}

		updateGalleryImageValueForBrokenValues(window.formattedVariant);
		let finalVariantValue = Object.values(window.formattedVariant).join(" / ");
		validatePrice(finalVariantValue);
	}
}

function selectStepOption(el) {
	const parent = el.parentNode;
	parent
		.querySelectorAll(".swatch-option, .toggle-option")
		.forEach((sib) => sib.classList.remove("selected"));
	el.classList.add("selected");

	const optionName = el.getAttribute("data-option-name");
	let value = el.getAttribute("data-value");

	// Handle Size formatting mismatch (e.g., customizer "8" -> Shopify "8\" X 10\"")
	if (
		optionName === "Size" &&
		window.productVariants &&
		window.productOptions
	) {
		const sizeIndex = window.productOptions.indexOf("Size");
		if (sizeIndex !== -1) {
			// Find a variant that has a Size option starting with this value + a quote
			const matchingVariant = window.productVariants.find(
				(v) =>
					v.options[sizeIndex] && v.options[sizeIndex].startsWith(value + '"'),
			);
			if (matchingVariant) {
				value = matchingVariant.options[sizeIndex];
			}
		}
	}

	if (optionName && value && window.formattedVariant) {
		window.formattedVariant[optionName] = value;

		// Update Distributed Memory (Hidden Inputs)
		// const hiddenInput = parent.closest('.swatch-group')?.querySelector('.customHiddenInputs');
		const hiddenInput = parent
			.closest(".swatch-group")
			?.querySelector(`.customHiddenInputs[data-name="${optionName}"]`);
		if (hiddenInput) {
			hiddenInput.value = value;
		}

		updateVariantId();
	}
	updateSubtotal();
}

function updateSubtotal() {
	const subtotalElements = document.querySelectorAll(".subTotalPrice");
	if (subtotalElements.length === 0) return;

	// Base price: set by updatePriceDisplay() from the real variant price,
	// or falls back to the initial product price from the data attribute.
	const basePrice =
		parseFloat(subtotalElements[0].getAttribute("data-base-price")) || 0;
	let extraCharges = 0;

	// Only add charges from "Extras" (separate add-on products added as their own cart line).
	// Size / Material / Frame pricing is already encoded in the Shopify variant price itself
	// and must not be added again here.
	document
		.querySelectorAll(".extra-item.selected .extra-hidden-checkbox")
		.forEach((el) => {
			extraCharges += parseFloat(el.getAttribute("data-price")) || 0;
		});

	const totalPrice = (basePrice + extraCharges).toFixed(2);
	subtotalElements.forEach((el) => {
		el.textContent = totalPrice;
	});
}

function resolveVariantOptionKey(rawKey) {
	if (!window.productOptions) return rawKey;
	// 1. exact
	if (window.productOptions.includes(rawKey)) return rawKey;
	const lc = rawKey.toLowerCase();
	// 2. case-insensitive
	const ciMatch = window.productOptions.find((opt) => opt.toLowerCase() === lc);
	if (ciMatch) return ciMatch;
	// 3. sanitised (strip spaces and non-alphanumeric on both sides)
	const sanitize = (s) =>
		s
			.toLowerCase()
			.replace(/\s+/g, "")
			.replace(/[^a-z0-9]/g, "");
	const sanitizedRaw = sanitize(rawKey);
	return (
		window.productOptions.find((opt) => sanitize(opt) === sanitizedRaw) ||
		rawKey
	);
}

function selectSwatch(
	name,
	sku,
	optionLabel,
	value,
	currentImage,
	extraCharges = 0,
	createUploaders,
	numberOfUploaders,
	swatchIndex,
	isNative,
) {
	// ── 1. Locate the hidden inputs for this group ──────────────────────────
	let swatchHiddenInput;
	let skuHiddenInput;

	if (optionLabel === "") {
		swatchHiddenInput = document.querySelector(
			`.${name}HiddenInput_${swatchIndex}`,
		);
		skuHiddenInput = document.querySelector(
			`.${name}_cors_HiddenInput_${swatchIndex}`,
		);
	} else {
		swatchHiddenInput = document.querySelector(`.${optionLabel}HiddenInput`);
		skuHiddenInput = document.querySelector(`.${optionLabel}_cors_HiddenInput`);
	}

	if (swatchHiddenInput) {
		swatchHiddenInput.value = "";
		swatchHiddenInput.value = value;
	}
	if (skuHiddenInput) {
		skuHiddenInput.value = "";
		skuHiddenInput.value = sku;
	}

	// ── 2. Visual selection: deselect all in this group, highlight current ──
	const swatchImages = document.querySelectorAll(
		`._${name}SwatchImages_${swatchIndex}`,
	);
	swatchImages.forEach((img) => {
		img.style.border = "none";
	});
	currentImage.style.border = "4px solid #5461C9";

	// ── 3. Optionally (re)build multi-image uploaders ───────────────────────
	if (createUploaders) {
		handleCreateMultiUploader(numberOfUploaders, name);
	}

	// ── 4. Update formattedVariant for variant resolution ────────────────────
	const opts = window.productOptions || [];
	let effectiveKey = null;

	if (isNative) {
		if (swatchHiddenInput && opts.length) {
			const allNativeInputs = [
				...document.querySelectorAll(".nativeHiddenInputs"),
			];
			const inputIndex = allNativeInputs.indexOf(swatchHiddenInput);
			if (inputIndex >= 0 && inputIndex < opts.length) {
				effectiveKey = opts[inputIndex];
				window.formattedVariant = window.formattedVariant || {};
				window.formattedVariant[effectiveKey] = value;
			}
		}
	} else {
		// Non-native: resolve key by name matching (unchanged behaviour).
		const resolvedLabel = optionLabel
			? resolveVariantOptionKey(optionLabel)
			: null;
		const resolvedName = resolveVariantOptionKey(name);
		effectiveKey =
			resolvedLabel && opts.includes(resolvedLabel)
				? resolvedLabel
				: opts.includes(resolvedName)
					? resolvedName
					: null;
		if (effectiveKey) {
			window.formattedVariant = window.formattedVariant || {};
			window.formattedVariant[effectiveKey] = value;
		}
	}

	const finalVariantValue =
		opts.length && window.formattedVariant
			? opts.map((opt) => window.formattedVariant[opt] || "").join(" / ")
			: "";
	validatePrice(finalVariantValue);

	handleGalleryImageSlider(effectiveKey || optionLabel || name, value);
}

function updateVariantTitle(stepName, value) {
	if (!window.formattedVariant) return;
	const key = resolveVariantOptionKey(stepName);
	window.formattedVariant[key] = value;
	updateVariantId();
}

function handleGalleryImageSlider(key, value) {
	if (window.formattedVariant && window.productOptions) {
		const resolvedKey = resolveVariantOptionKey(key);
		if (window.productOptions.includes(resolvedKey)) {
			window.formattedVariant[resolvedKey] = value;
		}
	}
	updateVariantId();
}

/**
 * Shopify seeds window.formattedVariant from selected_or_first_available_variant, which
 * often does not match customizer DOM defaults (e.g. Canvas vs Gallery Paper on toggles).
 * Re-read native/toggle hidden inputs and the combined Material and Frame string so
 * variant id and price match what the UI shows on first paint.
 */
function syncFormattedVariantFromCustomizerDom() {
	if (!window.formattedVariant || !window.productOptions) return;

	document.querySelectorAll(".nativeHiddenInputs").forEach((inp) => {
		const rawName = inp.getAttribute("data-name");
		if (!rawName || !inp.value) return;
		const key = resolveVariantOptionKey(rawName);
		if (key && window.productOptions.includes(key)) {
			window.formattedVariant[key] = inp.value;
		}
	});

	document.querySelectorAll(".toggleCheckboxes").forEach((inp) => {
		const rawName = inp.getAttribute("data-name");
		if (!rawName || !inp.value) return;
		const key = resolveVariantOptionKey(rawName);
		if (key && window.productOptions.includes(key)) {
			window.formattedVariant[key] = inp.value;
		}
	});

	getBrokenValues();
	if (window.productOptions.includes("Material and Frame") && brokenVariantString) {
		window.formattedVariant["Material and Frame"] = brokenVariantString;
	}
}

function getBackgroundPreselectParam() {
	try {
		return new URLSearchParams(window.location.search).get("background");
	} catch {
		return null;
	}
}

function findSwatchImageForBackgroundPreselect(group, backgroundParam) {
	if (!group || !backgroundParam) return null;
	const target = String(backgroundParam).trim().toLowerCase();
	if (!target) return null;

	for (const div of group.querySelectorAll(".swatchDiv")) {
		const labelEl = div.querySelector(".swatchImageLabel");
		const img = div.querySelector(".swatchImage");
		if (!labelEl || !img) continue;
		if (labelEl.textContent.trim().toLowerCase() === target) {
			return img;
		}
	}
	return null;
}

// Initial call to set the subtotal correctly on load
document.addEventListener("DOMContentLoaded", () => {
	// Reset the uploader count tracker so the first swatch click can rebuild properly
	localStorage.setItem("lastOptionSelected", 0);

	// Stamp a unique timestamp so the cart can correlate this order's line items
	const relatedProductInput = document.getElementById("relatedProduct");
	if (relatedProductInput) relatedProductInput.value = Date.now();

	syncCustomizerState();
	syncFormattedVariantFromCustomizerDom();
	updateSubtotal();
	updateVariantId();

	// Auto-fire swatches so hidden inputs hold defaults and uploaders initialize.
	// When arriving from a collection card (?background=), preselect that swatch.
	const preselectBackground = getBackgroundPreselectParam();
	document.querySelectorAll(".swatch-group").forEach((group) => {
		const matched =
			preselectBackground &&
			findSwatchImageForBackgroundPreselect(group, preselectBackground);
		const img = matched || group.querySelector(".swatchImage");
		if (img) img.click();
	});
});

function toggleExtraOption(el) {
	el.classList.toggle("selected");
	const checkbox = el.querySelector(".extra-hidden-checkbox");
	if (checkbox) {
		checkbox.checked = el.classList.contains("selected");
	}
	updateSubtotal();
}

function updateVariantId() {
	if (
		!window.productVariants ||
		!window.formattedVariant ||
		!window.productOptions
	)
		return;

	// Construct combined "Material and Frame" option if it exists in Shopify and is split in customizer
	if (window.productOptions.includes("Material and Frame")) {
		const material = window.formattedVariant["Material"] || "";
		const frame = window.formattedVariant["Frame"] || "";
		if (material && frame) {
			window.formattedVariant["Material and Frame"] = (
				material +
				" " +
				frame
			).trim();
		} else if (material) {
			// Default cases for initial load or partial selections
			if (material === "Gallery Paper") {
				window.formattedVariant["Material and Frame"] =
					"Gallery Paper Poster Only";
			} else if (material === "Canvas") {
				window.formattedVariant["Material and Frame"] = "Canvas Canvas Only";
			}
		}
	}

	// Build formatted string like Shopify expects: "Size / Material and Frame / ..."
	const formattedTitle = window.productOptions
		.map((opt) => window.formattedVariant[opt] || "")
		.join(" / ");

	// Find the variant
	let foundVariant = window.productVariants.find(
		(v) => v.title === formattedTitle,
	);

	if (foundVariant) {
		const idInput =
			document.querySelector("#variant-id-input") ||
			document.querySelector('input[name="id"]');
		if (idInput) idInput.value = foundVariant.id;

		// Update Gallery thumbnails
		const thumbnailImages = document.querySelectorAll(
			".product-gallery__thumbnail",
		);
		if (thumbnailImages) {
			thumbnailImages.forEach((image) => {
				const imageTitle = image.getAttribute("data-title");
				if (imageTitle === foundVariant.title) {
					image.click();
					thumbnailImages.forEach((t) => t.classList.remove("is-nav-selected"));
					image.classList.add("is-nav-selected");
				}
			});
		}

		// Update price displays from the real Shopify variant price
		updatePriceDisplay(foundVariant);

		// Set Jondo_id from jondo_data metafield lookup
		if (window.jondoData?.variants) {
			const jondoVariant = window.jondoData.variants.find(
				(v) => v.title === foundVariant.title,
			);
			const jondoInput = document.getElementById("JondoData");
			if (jondoVariant && jondoInput) {
				jondoInput.value = jondoVariant.id;
			}
		}
	}
}

async function handleAddToCart() {
	const nextBtn =
		document.querySelector(".customizer-submit-button") ||
		document.querySelector('[onclick="handleAddToCart()"]');
	if (nextBtn) {
		nextBtn.disabled = true;
		nextBtn.style.opacity = "0.5";
		nextBtn.textContent = "Adding...";
	}

	// Ensure the linking key exists before building any line item so the main
	// line (_original_unique_key) and add-on lines (_unique_key) share the same
	// value even if it was never initialized.
	const relatedProductInputForKey = document.getElementById("relatedProduct");
	if (relatedProductInputForKey && !String(relatedProductInputForKey.value).trim()) {
		relatedProductInputForKey.value = Date.now();
	}

	const items = [];

	// ── Variant check on add-to-cart (custom-design safety net) ──────────────
	// Re-resolve the variant id from the CURRENT selection right before submitting.
	// updateVariantId() rebuilds the "Size / Material and Frame" title from the live
	// selection and, on a match, syncs #variant-id-input (and Jondo_id). This guards
	// against a stale hidden input adding a variant that disagrees with the chosen
	// options. It reuses the existing resolution — no new matching logic — and is a
	// no-op when the input is already correct.
	if (typeof updateVariantId === "function") updateVariantId();

	const variantIdInput =
		document.querySelector("#variant-id-input") ||
		document.querySelector('input[name="id"]');
	const mainVariantId = variantIdInput ? variantIdInput.value : null;

	if (!mainVariantId) {
		alert("Please select all options.");
		if (nextBtn) {
			nextBtn.disabled = false;
			nextBtn.style.opacity = "1";
			nextBtn.textContent = "Add to Cart";
		}
		return;
	}

	// 1. Prepare properties (prefix pattern)
	const mainProperties = {};

	// Ensure window variables exist
	if (!window.productOptions || !window.formattedVariant) {
		alert("Internal error: Missing product state. Please refresh.");
		if (nextBtn) {
			nextBtn.disabled = false;
			nextBtn.style.opacity = "1";
			nextBtn.textContent = "Add to Cart";
		}
		return;
	}

	// Capture standard options as _option_ properties via positional DOM mapping.
	// .nativeHiddenInputs are rendered in metafield swatch-group order, which
	// matches Shopify productOptions order. Reading them directly avoids stale
	// formattedVariant state that can occur when nativeStepToOption isn't built.
	const nativeInputEls = [...document.querySelectorAll(".nativeHiddenInputs")];
	window.productOptions.forEach((optName, idx) => {
		const domVal = nativeInputEls[idx]?.value;
		const fvVal = window.formattedVariant[optName];
		const val = domVal || fvVal;
		if (val) mainProperties[`_option_${optName}`] = val;
	});

	// Collect all .customHiddenInputs (swatches, pet names, image URLs, etc.)
	// IMPORTANT: This must run unconditionally — mainForm may be null for custom-design products
	document.querySelectorAll(".customHiddenInputs").forEach((item) => {
		const propertyName = item.getAttribute("data-name");
		if (propertyName && item.value) {
			mainProperties[propertyName] = item.value;
		}
	});

	// Collect text/textarea inputs that use name="properties[...]" directly in the DOM
	// This covers front engraving, back engraving text, and any direct-name pet name fields
	document.querySelectorAll('[name^="properties["]').forEach((input) => {
		const match = input.name.match(/^properties\[(.+?)\]$/);
		if (!match) return;
		const propName = match[1];
		if (input.type === "checkbox") {
			// Only capture checkbox value when checked (e.g. Back Engravings)
			if (input.checked && input.value && input.value !== "No") {
				mainProperties[propName] = input.value;
			}
		} else if (input.value && !mainProperties[propName]) {
			mainProperties[propName] = input.value;
		}
	});

	// Final Payload Preparation (Modern API)
	items.push({
		id: mainVariantId,
		quantity: 1,
		properties: mainProperties,
	});

	// Use the same timestamp key that ties all line items together for Jondo
	const uniqueKey = document.getElementById("relatedProduct")?.value || "";

	// Add back engraving product as a separate cart item when checkbox is checked
	const backEngravingIdInput = document.querySelector(".backEngravingsIDInput");
	document.querySelectorAll(".backEngravingCheckbox").forEach((checkbox) => {
		if (
			checkbox.checked &&
			backEngravingIdInput &&
			backEngravingIdInput.value
		) {
			items.push({
				id: backEngravingIdInput.value,
				quantity: 1,
				properties: { _unique_key: uniqueKey },
			});
		}
	});

	// Add Extras (Add-ons)
	document.querySelectorAll(".extra-item.selected").forEach((extra) => {
		const variantId = extra.getAttribute("data-variant-id");
		if (variantId) {
			items.push({
				id: variantId,
				quantity: 1,
				properties: { _unique_key: uniqueKey },
			});
		}
	});

	// Submit via AJAX to /cart/add.js
	try {
		const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ items: items }),
		});
		const data = await response.json();

		if (data.status) {
			alert("Error: " + (data.description || data.message));
			if (nextBtn) {
				nextBtn.disabled = false;
				nextBtn.style.opacity = "1";
				nextBtn.textContent = "Add to Cart";
			}
		} else {
			window.location.href = window.Shopify.routes.root + "cart";
		}
	} catch (error) {
		console.error("Add to Cart Error:", error);
		alert("Something went wrong. Please try again.");
		if (nextBtn) {
			nextBtn.disabled = false;
			nextBtn.style.opacity = "1";
			nextBtn.textContent = "Add to Cart";
		}
	}
}

// ── Dynamic multi-uploader (controlled by swatch selection) ──────────────────

function getOrdinalSuffix(n) {
	if (n % 100 >= 11 && n % 100 <= 13) return "th";
	switch (n % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
}

/**
 * Keep the "Upload Your Xth Pet Photo" label correct as uploaders are added/removed.
 */
function handleImageUploaderLabels() {
	const allUploaders = document.querySelectorAll(".uploaderSection");
	const firstLabel = document.querySelector(".uploaderSection_1 label");
	if (!firstLabel) return;

	if (allUploaders.length < 1) {
		firstLabel.style.display = "flex";
		firstLabel.textContent = "Upload Image:";
	} else if (allUploaders.length > 1) {
		firstLabel.style.display = "flex";
	}
}

function createFrontEngravingContainer(frontEngravings, index) {
	if (!frontEngravings) return null;

	const container = document.createElement("div");
	container.classList.add("frontEngravingsContainer");

	const label = document.createElement("p");
	label.classList.add("frontEngraving");
	label.textContent = frontEngravings.label;
	if (frontEngravings.optional) {
		const opt = document.createElement("span");
		opt.classList.add("optionalText");
		opt.innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;(Optional)";
		label.appendChild(opt);
	}
	label.innerHTML += ":";

	const note = document.createElement("p");
	note.classList.add("frontEngravingNote");
	note.textContent = "Note: " + frontEngravings.note;

	const textarea = document.createElement("textarea");
	textarea.classList.add("input", "frontEngravingInput");
	textarea.maxLength = 12;
	textarea.name = `properties[Front Engraving ${index}]`;
	textarea.placeholder = frontEngravings.input_field_placeholder || "";
	textarea.style.border = "1px solid";
	textarea.style.borderRadius = "10px";

	container.appendChild(label);
	container.appendChild(note);
	container.appendChild(textarea);
	return container;
}

function createBackEngravingContainer(backEngravings, index, stepName) {
	if (!backEngravings) return null;

	const mainContainer = document.createElement("div");
	mainContainer.classList.add("backEngravingsMainContainer");

	// Hidden ID input
	const idInput = document.createElement("input");
	idInput.type = "hidden";
	idInput.classList.add("backEngravingsIDInput");
	idInput.value = backEngravings.id || "";

	// Checkbox container
	const checkboxContainer = document.createElement("div");
	checkboxContainer.classList.add("optionCheckboxContainer");

	const checkbox = document.createElement("input");
	checkbox.type = "checkbox";
	checkbox.classList.add(
		"backEngravingCheckbox",
		`backEngravingCheckbox_${index}`,
	);
	checkbox.name = `properties[Back Engravings ${index}]`;
	checkbox.value = "No";
	checkbox.setAttribute(
		"onchange",
		`handleBackEngraving(this,${index},'${stepName.toLowerCase().replace(/\s/g, "")}',${backEngravings.extra_charges || 0})`,
	);

	checkboxContainer.appendChild(checkbox);
	checkboxContainer.appendChild(idInput);
	mainContainer.appendChild(checkboxContainer);

	// Label + description
	const detailMain = document.createElement("div");
	detailMain.classList.add("optionDetailMainContainer");
	const detailInner = document.createElement("div");
	detailInner.classList.add("optionDetailContainer");

	const optLabel = document.createElement("div");
	optLabel.classList.add("optionLabel");
	optLabel.textContent = backEngravings.label || "";

	const optDesc = document.createElement("div");
	optDesc.classList.add("optionDescription");
	optDesc.textContent = backEngravings.descritpion || "";

	detailInner.appendChild(optLabel);
	detailInner.appendChild(optDesc);
	detailMain.appendChild(detailInner);
	mainContainer.appendChild(detailMain);

	// Price
	const price = document.createElement("div");
	price.classList.add("optionPrice");
	price.textContent = `+$${backEngravings.extra_charges || 0}`;
	mainContainer.appendChild(price);

	// Text input
	const inputContainer = document.createElement("div");
	inputContainer.classList.add("backEngravingsInputContainer");

	const textarea = document.createElement("textarea");
	textarea.maxLength = 32;
	textarea.disabled = true;
	textarea.classList.add(
		"input",
		"backEngravingsInput",
		`backEngravingsInput_${index}`,
	);
	textarea.name = `properties[Back Engraving text ${index}]`;
	textarea.placeholder = backEngravings.input_field_placeholder || "";
	textarea.setAttribute(
		"oninput",
		`handleBackEngravingInput(this,${index},'${stepName.toLowerCase().replace(/\s/g, "")}')`,
	);

	inputContainer.appendChild(textarea);
	mainContainer.appendChild(inputContainer);
	return mainContainer;
}

function createImagesUploaders(i, stepname) {
	const imageUploaderContainer = document.querySelector(
		".multi-image-uploader",
	);
	// Button name for showHideNextButton always comes from the container's data-value
	stepname = imageUploaderContainer.getAttribute("data-value") || stepname;

	const uploaderSection = document.createElement("div");
	uploaderSection.classList.add(`uploaderSection_${i}`, "uploaderSection");

	const suffix = getOrdinalSuffix(i);

	const uploaderLabel = document.createElement("label");
	uploaderLabel.classList.add("custom-uploader-label");

	uploaderLabel.textContent = `Upload ${i}${suffix} Pet Image:`;

	const imageUploaderDiv = document.createElement("div");
	imageUploaderDiv.classList.add("image-uploader");
	imageUploaderDiv.id = `image-uploader-${i}`;

	// Close button – class uses DASH to match portraitDragNdrop selectors
	const closeBtn = document.createElement("button");
	closeBtn.type = "button";

	closeBtn.classList.add(`close-button-${i}`, "close-button-simple");
	closeBtn.textContent = "✖";

	// Selected-image container
	const selectedImg = document.createElement("div");
	selectedImg.classList.add(
		`selected-image-${i}`,
		"selected-image-container-simple",
	);

	// Hidden input – matches static template: customHiddenInputs + data-name (no name attr)
	const hiddenInput = document.createElement("input");
	hiddenInput.type = "hidden";
	hiddenInput.value = "";
	hiddenInput.classList.add(
		"customHiddenInputs",
		`hiddenInputSimple-${i}`,
		"hiddenInputImage",
	);
	hiddenInput.setAttribute("data-name", `_image_url_${i}`);

	// Upload outer – class uses DASH to match portraitDragNdrop selectors
	const uploadOuter = document.createElement("div");
	uploadOuter.classList.add(`uploadOuter-${i}`, "uploadOuter");

	const dragBox = document.createElement("span");
	dragBox.classList.add("dragBoxUnique");

	const dragText = document.createElement("span");
	dragText.classList.add("dragBoxText");
	dragText.textContent = "Drag + Drop";

	const fileInput = document.createElement("input");
	fileInput.type = "file";
	fileInput.classList.add(`image_uploader_${i}`, "fileInput");
	fileInput.id = `uploadFile-${i}`;
	fileInput.setAttribute("onclick", "this.value=null");
	// Pass stepname as buttonName so showHideNextButton targets the correct step button
	fileInput.setAttribute(
		"onchange",
		`portraitDragNdrop(event,'image-uploader-${i}',${i},'${stepname}',document.querySelectorAll('.hiddenInputImage').length)`,
	);
	fileInput.setAttribute("ondragover", "drag(event)");
	fileInput.setAttribute("ondrop", "drop(event)");

	const orSpan = document.createElement("span");
	orSpan.classList.add("orText");
	const orStrong = document.createElement("strong");
	orStrong.textContent = "or";
	orSpan.appendChild(orStrong);

	const selectLabel = document.createElement("label");
	selectLabel.classList.add(
		"btn",
		"btn-primary",
		"selectFileButton",
		"custom-select-file-button",
	);
	selectLabel.setAttribute("for", `uploadFile-${i}`);
	selectLabel.textContent = "Select File";

	dragBox.appendChild(dragText);
	dragBox.appendChild(fileInput);
	dragBox.appendChild(orSpan);
	dragBox.appendChild(selectLabel);
	uploadOuter.appendChild(dragBox);

	imageUploaderDiv.appendChild(closeBtn);
	imageUploaderDiv.appendChild(hiddenInput);
	imageUploaderDiv.appendChild(selectedImg);
	imageUploaderDiv.appendChild(uploadOuter);

	uploaderSection.appendChild(uploaderLabel);
	uploaderSection.appendChild(imageUploaderDiv);

	// ── Optional pet-name field + engraving fields from metaValues ──────────
	if (window.metaValues && window.metaValues.steps) {
		window.metaValues.steps.forEach((step) => {
			if (step.identifier !== "image_uploader") return;

			// Optional pet name field
			if (step.optional_pet_name_field) {
				const nameField = document.createElement("div");
				nameField.className = "pet-name-field custom-option-text-field";

				const swatchesLabel = document.createElement("div");
				swatchesLabel.className = "swatches-label";

				const swatchesLabelInner = document.createElement("div");

				const nameLabel = document.createElement("label");
				nameLabel.className = "pet-name-field__label";
				nameLabel.setAttribute("for", `custom-text-field-${i}`);
				nameLabel.innerHTML = "<span>Pet Name (Optional)</span>";

				swatchesLabelInner.appendChild(nameLabel);
				swatchesLabel.appendChild(swatchesLabelInner);

				const nameInput = document.createElement("input");
				nameInput.type = "text";
				nameInput.id = `custom-text-field-${i}`;
				nameInput.classList.add(
					"customHiddenInputs",
					`multiTextField_${i}`,
					"input",
					"pet-name-field__input",
					"custom-option-text-field__input",
				);
				nameInput.setAttribute("data-name", `Pet Name ${i}`);
				nameInput.setAttribute("aria-label", "Pet Name (Optional)");
				nameInput.placeholder = "Type Your Pet's Name Here";

				nameField.appendChild(swatchesLabel);
				nameField.appendChild(nameInput);
				uploaderSection.appendChild(nameField);
			}

			// Front engraving
			if (step.front_engraving && step.front_engraving.display) {
				const fe = createFrontEngravingContainer(step.front_engraving, i);
				if (fe) {
					uploaderSection.appendChild(fe);
					uploaderSection.style.marginBottom = "30px";
				}
			}

			// Back engraving
			if (step.back_engraving && step.back_engraving.display) {
				const be = createBackEngravingContainer(
					step.back_engraving,
					i,
					stepname,
				);
				if (be) {
					uploaderSection.appendChild(be);
					uploaderSection.style.marginBottom = "30px";
				}
			}
		});
	}

	imageUploaderContainer.appendChild(uploaderSection);
}

function handleCreateMultiUploader(numberOfUploaders, stepname) {
	const imageUploaderContainer = document.querySelector(
		".multi-image-uploader",
	);
	if (!imageUploaderContainer) return;

	const lastSelectedOption = parseInt(
		localStorage.getItem("lastOptionSelected") || "0",
	);

	// First call after page load: wipe any statically-rendered uploaders
	if (lastSelectedOption === 0) {
		imageUploaderContainer.innerHTML = "";
	}

	if (numberOfUploaders > lastSelectedOption) {
		// Add uploaders from (lastSelectedOption + 1) up to numberOfUploaders
		const startIndex = lastSelectedOption === 0 ? 1 : lastSelectedOption + 1;
		for (let idx = startIndex; idx <= numberOfUploaders; idx++) {
			createImagesUploaders(idx, stepname);
		}

		// Hide next button until all photos are uploaded
		const uploadersButtonName =
			imageUploaderContainer.getAttribute("data-value");
		if (
			numberOfUploaders >
			parseInt(localStorage.getItem("lastOptionSelected") || "0")
		) {
			showHideNextButton(uploadersButtonName, false);
		}
		handleImageUploaderLabels();
	} else if (numberOfUploaders < lastSelectedOption) {
		// Remove extra uploaders
		document.querySelectorAll(".uploaderSection").forEach((el, arrayIndex) => {
			if (arrayIndex >= numberOfUploaders && arrayIndex < lastSelectedOption) {
				el.remove();
			}
		});
		handleImageUploaderLabels();
	}

	localStorage.setItem("lastOptionSelected", numberOfUploaders);
}

// Multi-Image Uploader Logic
function drag(e) {
	e.preventDefault();
}

function drop(e) {
	e.preventDefault();
}

async function portraitDragNdrop(
	event,
	containerId,
	number,
	buttonName,
	numberImages,
	swatchLabel,
) {
	let hiddenInput = document.querySelector(`.hiddenInputSimple-${number}`);
	var files = event.target.files;

	if (files.length > 1) {
		alert("Please select only one image file.");
		return;
	}

	var file = files[0];
	const ext = files[0].name.split(".").pop().toLowerCase();

	if (!file.type.startsWith("image/")) {
		if (ext !== "heic" && ext !== "heif") {
			alert("Please select only image files.");
			return;
		}
	}

	const allowedTypes = [
		"image/jpg",
		"image/png",
		"image/bmp",
		"image/jpeg",
		"image/heic",
		"image/heif",
	];
	if (!allowedTypes.includes(file.type)) {
		if (ext !== "heic" && ext !== "heif") {
			alert(
				`This type of image is not allowed. Please use only jpg, png, bmp, heic or heif.`,
			);
			return;
		}
	}

	if (files[0].size > 15 * 1024 * 1024) {
		alert("Please select images smaller than 15MB.");
		return;
	}

	let uploadedImageName;
	var previewImg = document.createElement("img");
	previewImg.src =
		"https://cdn.shopify.com/s/files/1/0537/2585/5916/files/Spinner-1s-200px.gif";

	let imageContainer = document.querySelector(`.selected-image-${number}`);
	let closeBtn = document.querySelector(`.close-button-${number}`);
	let uploaderBox = document.querySelector(`#image-uploader-${number}`);

	closeBtn.style.display = "block";
	uploaderBox.style.padding = "20px";

	imageContainer.innerHTML = "";
	imageContainer.style.position = "relative";

	previewImg.setAttribute("alt", "Image ");
	previewImg.setAttribute("id", "previewImageSimple");

	const progressWrapper = document.createElement("div");
	progressWrapper.className = "modern-progress-wrapper";
	progressWrapper.innerHTML = `
      <svg class="modern-progress-circle">
        <circle class="modern-bg" cx="22" cy="22" r="19.5"></circle>
        <circle class="modern-bar" cx="22" cy="22" r="19.5"></circle>
      </svg>
      
    `;

	const miniProgressWrapper = document.createElement("div");
	miniProgressWrapper.className = "mini-progress-wrapper";
	miniProgressWrapper.innerHTML = `
      <svg class="mini-progress-circle">
        <circle class="mini-bg" cx="12" cy="12" r="10.5"></circle>
        <circle class="mini-bar" cx="12" cy="12" r="10.5"></circle>
      </svg>
      <div class="mini-progress-text">0%</div>
    `;

	imageContainer.appendChild(progressWrapper);
	imageContainer.appendChild(miniProgressWrapper);
	imageContainer.appendChild(previewImg);

	document.querySelector(`.uploadOuter-${number}`).style.display = "none";
	uploaderBox.classList.add("has-image");

	const formData = new FormData();
	formData.append("image", files[0]);

	const xhr = new XMLHttpRequest();
	xhr.upload.addEventListener("progress", function (e) {
		if (e.lengthComputable) {
			const percent = Math.round((e.loaded / e.total) * 100);
			updateProgress(miniProgressWrapper, percent, "mini");
		}
	});

	xhr.onload = function () {
		if (progressWrapper.parentNode) progressWrapper.remove();
		if (miniProgressWrapper.parentNode) miniProgressWrapper.remove();

		const statusBadge = document.createElement("div");
		statusBadge.className = "upload-status-badge";
		imageContainer.appendChild(statusBadge);

		if (xhr.status === 200 || xhr.status === 201) {
			const data = JSON.parse(xhr.responseText);
			previewImg.src = data.imageUrl;
			hiddenInput.value = data.imageUrl;

			const containerWidth = 250;
			const containerHeight = 250;
			const imageAspectRatio =
				previewImg.naturalWidth / previewImg.naturalHeight;

			let imageWidth, imageHeight;
			if (imageAspectRatio >= 1) {
				// Landscape or square image
				imageWidth = containerWidth;
				imageHeight = containerWidth / imageAspectRatio;
			} else {
				// Portrait image
				imageHeight = containerHeight;
				imageWidth = containerHeight * imageAspectRatio;
			}

			previewImg.style.width = `${imageWidth}px`;
			previewImg.style.height = `${imageHeight}px`;
			previewImg.style.objectFit = "contain";

			statusBadge.textContent = "Image Uploaded";
			statusBadge.classList.add("success");

			const imageUrl = data.imageUrl;
			const parts = imageUrl.split("/");
			uploadedImageName = parts[parts?.length - 1];

			let isAllImagesUploaded = validateAllUploaders(numberImages);
			let isBackEngravingsValid = validateBackEngravingsCheckboxesWithInputs();
			showHideNextButton(
				buttonName,
				isAllImagesUploaded && isBackEngravingsValid,
			);
		} else {
			statusBadge.textContent = "Failed";
			statusBadge.classList.add("error");
		}
	};

	xhr.onerror = function () {
		if (progressWrapper.parentNode) progressWrapper.remove();
		if (miniProgressWrapper.parentNode) miniProgressWrapper.remove();

		const statusBadge = document.createElement("div");
		statusBadge.className = "upload-status-badge error";
		statusBadge.textContent = "Failed";
		imageContainer.appendChild(statusBadge);
	};
	const apiUrl = window.api_details?.[0]?.url || "";
	const apiToken = window.api_details?.[0]?.api_token || "";

	xhr.open("POST", `${apiUrl}image_uploader/print_image`);

	// Define headers
	const headers = {
		"api-token": apiToken,
		Authorization: `Bearer ${apiToken}`,
	};

	// Set headers
	Object.keys(headers).forEach((key) => {
		if (headers[key]) xhr.setRequestHeader(key, headers[key]);
	});

	xhr.send(formData);

	closeBtn.onclick = (e) => {
		e.preventDefault();
		imageContainer.innerHTML = "";
		document.querySelector(`.uploadOuter-${number}`).style.display = "block";
		closeBtn.style.display = "none";
		hiddenInput.value = "";
		uploaderBox.style.padding = "0px";
		uploaderBox.classList.remove("has-image");
		showHideNextButton(buttonName, false);
	};

	// Don't validate here - wait for xhr.onload to complete
}

function updateProgress(wrapper, percent, type = "modern") {
	const bar = wrapper.querySelector(
		type === "modern" ? ".modern-bar" : ".mini-bar",
	);
	const text = wrapper.querySelector(
		type === "modern" ? ".modern-progress-text" : ".mini-progress-text",
	);
	const radius = type === "modern" ? 19.5 : 10.5;
	const circumference = 2 * Math.PI * radius;
	const offset = circumference - (percent / 100) * circumference;

	if (bar) bar.style.strokeDashoffset = offset;

	if (text) {
		text.textContent = percent >= 100 ? "100%" : `${Math.round(percent)}%`;
	}
}

function validateAllUploaders(total) {
	const allHiddenInputs = document.querySelectorAll(".hiddenInputImage");
	if (allHiddenInputs.length === 0) return true;
	return Array.from(allHiddenInputs).every((input) => input.value !== "");
}

function showHideNextButton(buttonName, show) {
	const nextButton = document.querySelector(`.${buttonName}NextButton`);
	if (nextButton) {
		if (show) {
			nextButton.style.opacity = "1";
			nextButton.style.pointerEvents = "auto";
			nextButton.disabled = false;
		} else {
			nextButton.style.opacity = "0.3";
			nextButton.style.pointerEvents = "none";
			nextButton.disabled = true;
		}
	}
}

function handlePhotoGuidePopup(show) {
	const modal = document.getElementById("photoGuideModal");
	if (modal) {
		modal.style.display = show ? "block" : "none";
		document.body.style.overflow = show ? "hidden" : "";
	}
}

function handleBackEngraving(checkbox, index, buttonName, price) {
	const backEngravingInput = document.querySelector(
		`.backEngravingsInput_${index}`,
	);
	if (checkbox.checked) {
		checkbox.value = "Yes";
		if (backEngravingInput) backEngravingInput.disabled = false;
	} else {
		checkbox.value = "No";
		if (backEngravingInput) {
			backEngravingInput.disabled = true;
			backEngravingInput.value = "";
		}
	}

	const isBackEngravingsValid = validateBackEngravingsCheckboxesWithInputs();
	const isAllImagesUploaded = validateAllUploaders(
		document.querySelectorAll(".hiddenInputImage").length,
	);
	showHideNextButton(buttonName, isBackEngravingsValid && isAllImagesUploaded);

	// Update subtotal price
	const priceDivs = document.querySelectorAll(".subTotalPrice");
	priceDivs.forEach((div) => {
		const currentPrice = parseFloat(div.textContent) * 100;
		const delta = (price || 0) * 100;
		const newPrice = checkbox.checked
			? currentPrice + delta
			: currentPrice - delta;
		div.innerHTML = (newPrice / 100).toFixed(2);
	});
}

function handleBackEngravingInput(input, index, buttonName) {
	const isBackEngravingsValid = validateBackEngravingsCheckboxesWithInputs();
	const isAllImagesUploaded = validateAllUploaders(
		document.querySelectorAll(".hiddenInputImage").length,
	);
	showHideNextButton(buttonName, isBackEngravingsValid && isAllImagesUploaded);
}

function validateBackEngravingsCheckboxesWithInputs() {
	const checkboxes = document.querySelectorAll(".backEngravingCheckbox");
	let isValid = true;
	checkboxes.forEach((checkbox, i) => {
		if (checkbox.checked) {
			const associatedInput = document.querySelector(
				`.backEngravingsInput_${i + 1}`,
			);
			if (!associatedInput || associatedInput.value.trim().length === 0) {
				isValid = false;
			}
		}
	});
	return isValid;
}

// Handle dragover highlight
document.addEventListener(
	"dragover",
	function (e) {
		const target = e.target.closest(".image-uploader");
		if (target) {
			target.classList.add("dragover");
		}
	},
	false,
);

document.addEventListener(
	"dragleave",
	function (e) {
		const target = e.target.closest(".image-uploader");
		if (target) {
			target.classList.remove("dragover");
		}
	},
	false,
);

document.addEventListener(
	"drop",
	function (e) {
		const target = e.target.closest(".image-uploader");
		if (target) {
			target.classList.remove("dragover");
		}
	},
	false,
);

// ── Size Guide Modal ──
function handleSizeChartPopup() {
	const modal = document.getElementById("sizeGuideModal");
	if (!modal) return;
	modal.classList.toggle("is-open");
	document.body.style.overflow = modal.classList.contains("is-open")
		? "hidden"
		: "";
}

function closeSizeChartPopup() {
	const modal = document.getElementById("sizeGuideModal");
	if (!modal) return;
	modal.classList.remove("is-open");
	document.body.style.overflow = "";
}

function handleSizeGuideOverlayClick(event) {
	// Close only when the dark backdrop itself is clicked (not the content inside)
	if (event.target === event.currentTarget) {
		closeSizeChartPopup();
	}
}
